import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography
} from "@material-ui/core";
import { getFormularioCud, postPracticasDiscapacidad } from "../../../../../actions/discapacidad/discapacidadActions";
import { IntegracionAddPractica } from "../../ingreso/IntegracionAddPractica";
import IntegracionPractica from "../../ingreso/IntegracionPractica";
import { startAlerta } from "../../../../../actions/ui/alertas";

export const DiagnosticoPracticaIntegracionMenu = (props) => {
  const dispatch = useDispatch();

  const { solicitudSeleccionada = {},formularioCud } = useSelector(
    (state) => state.discapacidad
  );

  const [openAgregarPractica, setOpenAgregarPractica] = useState(false);
  const [hasChangesPractica, setHasChangesPractica] = useState(false);


  const onClickSavesHandler = () => {
    if (!solicitudSeleccionada?.practicas.length) {
      dispatch(
        startAlerta(
          `Debe agregar la práctica."
          }`,
          "error",
          "Error"
        )
      );
    } else {
      if (hasChangesPractica) {
        dispatch(
          postPracticasDiscapacidad(
            {
              practicas: solicitudSeleccionada?.practicas,
              idSolicitud: solicitudSeleccionada?.idSolicitud
            }
          )
        );
      }
    }
  };

  useEffect(() => {
    dispatch(getFormularioCud(solicitudSeleccionada?.idAfiliado,true))
  }, [solicitudSeleccionada])
console.log(solicitudSeleccionada)
  return (
    <>
      <Table
        style={{ width: "80%", margin: "auto" }}
      >
        <TableBody>
          <TableRow>
            <TableCell
              style={{
                borderBottom: "0",
                fontSize: "1rem",
                verticalAlign: "bottom",
                position: "relative",
                bottom: "2px",
              }}
            >
              Diagnostico:
            </TableCell>
            <TableCell
              style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
            >
              {formularioCud?.diagnosticos?.map((item) => (
                <Typography>{item.diagnostico.descripcion}</Typography>
              ))}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <div style={{ textAlign: "center", margin: "2rem 0" }}>
        {(!Array.isArray(solicitudSeleccionada?.practicas) ||
          solicitudSeleccionada?.practicas.length === 0) &&
          !openAgregarPractica && !props.disabled &&
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenAgregarPractica(true)}
          >
            + Agregar Practica
          </Button>
        }
      </div>
      {openAgregarPractica && (
        <IntegracionAddPractica
          auditoria={true}
          postAgregar={() => setOpenAgregarPractica(false)}
          setHasChangesPractica={() => setHasChangesPractica(true)}
        />
      )}
      {Array.isArray(solicitudSeleccionada?.practicas) && solicitudSeleccionada?.practicas &&
        solicitudSeleccionada?.practicas.map((practica, index) => {
          return (
            <IntegracionPractica
              key={index}
              auditoria={true}
              practica={practica}
              disabled={props.disabled}
              setHasChangesPractica={() => setHasChangesPractica(true)}
            />
          );
        })}
      <div style={{ textAlign: "center" }}>
        <Button
          onClick={onClickSavesHandler}
          disabled={props.disabled || (!hasChangesPractica)}
          variant="contained"
          color="primary"
        >
          Guardar Cambios
        </Button>
      </div>
    </>
  );
};
